import { useAccountSettings } from './useSettings';
import { isAccountExploreDisabled } from '../utils/exploreAccess';

export const useCurrentUserProfile = () => {
  const { data: account, isSuccess } = useAccountSettings();
  const exploreDisabled = isAccountExploreDisabled(account);
  const isExploreAccessResolved = isSuccess;
  const canSeeExplore = isExploreAccessResolved && !exploreDisabled;

  return { canSeeExplore, isExploreAccessResolved };
};
